import React from 'react';

import { UploadingFile } from './types';

import cn from '~/utils/cn';

const ProgressBar: React.FC<{ uploadedFile: UploadingFile }> = ({ uploadedFile }) => {
  return (
    <div className="bg-grey-200 h-2 w-full overflow-hidden rounded">
      <div
        className={cn('bg-blue-1000 h-full transition-all duration-200', {
          'bg-green-600': uploadedFile.status === 'success',
          'bg-red-700': uploadedFile.status === 'error',
        })}
        style={{ width: `${uploadedFile.progress}%` }}
      />
    </div>
  );
};

export default ProgressBar;
